// extracted by mini-css-extract-plugin
module.exports = {"comment-container":"styles-module__comment-container___mcvhA","note-text":"styles-module__note-text___5uoLB"};